import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NavLink } from 'react-router-dom';

import MainButton from '../../shared/MainButton';

export default class Navbar extends Component {
  render() {
    const {
      steps,
      currentIndex,
      onNext,
      history,
      valid,
      baseUrl,
      previewOnly
    } = this.props;

    return (
      <div
        style={{
          display: 'flex', justifyContent: 'space-between', marginBottom: 50, marginLeft: 'auto', marginRight: 'auto', marginTop: 50,
        }}
      >
        <MainButton
          /* eslint-disable-next-line */
          onClick={() => {
            if (previewOnly) return history.push('/');

            const ok = confirm('Are you sure you want to cancel and lose all changes? You can return to a previous step by clicking the number');

            if (!ok) return;

            if (currentIndex === 0) {
              return history.push('/');
            }

            history.push(baseUrl);
          }}
        >
          {
            /* eslint-disable-next-line */
            previewOnly ? 'CLOSE' : currentIndex === 0 ? 'CANCEL' : 'START OVER'
          }
        </MainButton>
        {steps.map((step, key) => {
          if (!step.label) return null;
          return (
            <NavLink
            /* eslint-disable-next-line */
              key={key}
              to={`${baseUrl}/${step.path}`}
              style={{ textDecoration: 'none' }}
              onClick={(e) => {
                if (currentIndex < key) e.preventDefault();
                if (currentIndex + 1 === steps.length) e.preventDefault();
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <CircleButtonContainer>
                  <CircleButton
                    color={currentIndex === key ? '#7392ee' : '#e2e5ef'}
                    /* eslint-disable-next-line */
                    backgroundColor={currentIndex === key ? 'white' : key < currentIndex ? '#37b8ca' : '#f7f8f9'}
                  >
                    {key < currentIndex ? <img src="/images/check.png" style={{ width: 15, height: 12 }} alt="check" /> : key + 1}
                  </CircleButton>
                </CircleButtonContainer>
                <CircleButtonLabel
                  color={currentIndex === key ? '#384076' : '#9da1bb'}
                >
                  {step.label.toUpperCase()}
                </CircleButtonLabel>
              </div>
            </NavLink>
          );
        })}
        <MainButton
          style={{
            backgroundColor: valid ? '#37b8ca' : '#98dbe4',
            color: 'white',
          }}
          onClick={valid ? onNext : () => {}}
        >
          CONTINUE
        </MainButton>
        <Line />
      </div>
    );
  }
}

Navbar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  history: PropTypes.objectOf({
    push: PropTypes.func.isRequired,
  }).isRequired,
  valid: PropTypes.bool.isRequired,
  baseUrl: PropTypes.string.isRequired,
  previewOnly: PropTypes.bool.isRequired,
};

const CircleButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CircleButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.color} !important;
  background-color: ${props => props.backgroundColor};
  border: 3px solid #e2e5ef !important;
  border-radius: 25px;
  width: 35px;
  height: 35px;
  border: 3px solid
  text-decoration: none
  font-family: 'Karla', sans-serif;
  font-weight: 800;
`;

const CircleButtonLabel = styled.div`
  position: relative;
  top: -65px;
  color: ${props => props.color} !important;
  font-weight: 800;
  font-family: 'Karla', sans-serif;
  font-size: 13px;
`;

const Line = styled.div`
  position: absolute;
  left: 150px;
  right: 150px;
  z-index: -1;
  height: 3px;
  background-color: #e2e5ef;
  margin-top: 19px;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
`;



// WEBPACK FOOTER //
// ./client/Upload/components/Navbar.js